import { render } from "./ExpedicionesCargarRutaRepartoPage.vue?vue&type=template&id=4eb2bae8&scoped=true"
import script from "./ExpedicionesCargarRutaRepartoPage.vue?vue&type=script&lang=js"
export * from "./ExpedicionesCargarRutaRepartoPage.vue?vue&type=script&lang=js"

import "./ExpedicionesCargarRutaRepartoPage.vue?vue&type=style&index=0&id=4eb2bae8&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb2bae8"]])

export default __exports__